import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFieldList,
	addNewField,
	updateField,
	deleteField,
	getField,
} from '../field/thunk';

export const initialState = {
	itemFieldList: [],
	itemFieldDetail: null,
	isFieldLoading: false,
	isFieldSuccess: false,

	fieldList: [],
	fieldListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const FieldSlice = createSlice({
	name: 'Field',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getField.fulfilled, (state, action) => {
			state.isFieldLoading = false;
			state.isFieldSuccess = true;
			state.itemFieldDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getField.pending, state => {
			state.isFieldLoading = true;
			state.isFieldSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getField.rejected, (state, action) => {
			state.isFieldLoading = false;
			state.isFieldSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getFieldList.fulfilled, (state, action) => {
			state.fieldList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getFieldList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getFieldList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewField.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.fieldList.push(action.payload);
			state.requireCloseModal = true;
		});
		builder.addCase(addNewField.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewField.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updateField.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;
			const index = state.fieldList.findIndex(
				field => field.id === action.payload.id
			);
			state.fieldList[index] = action.payload;
			state.requireCloseModal = true;
		});
		builder.addCase(updateField.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateField.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deleteField.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.fieldList = state.fieldList.filter(
				field => field.id !== action.payload.id
			);
		});
		builder.addCase(deleteField.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteField.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal } = FieldSlice.actions;

export default FieldSlice.reducer;
